import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";

import OutreachAttachmentsTable, {
    OutreachAttachmentTableProps
} from "../../../pages/program/outreach/components/OutreachAttachmentsTable";


interface OwnProps extends SlideOverProps, OutreachAttachmentTableProps {}

type Props = OwnProps;

// @ts-ignore
const OutreachAttachmentsTableModal = NiceModal.create<Props>(({onClose, header, ...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <OutreachAttachmentsTable {...rest}/>
        </SlideOver>
    )
})

export default OutreachAttachmentsTableModal;
